import type { Dispatch, SetStateAction } from 'react';
import { Alert } from '@ksyos/design-system';
import type { ICustomControlProcedureReadProps } from '../interfaces/';
import type { ICustomControlProcedureAddEditProps } from '../interfaces/customControlProcedureAddEditProps';
import { HeaderDivider } from '../../../elements/common';
import { OphthalmologyDropzoneProcedureAddEdit } from '../TFO/v1/OphthalmologyDropzoneProcedureAddEdit';
import { OphthalmologyDropzoneRead } from '../TFO/v1/OphthalmologyDropzoneRead';

interface IOrthOV1ProcedurePhotosProps {
    isOrthOFol?: boolean;
    title?: string;
}

interface IOrthOV1ProcedurePhotosAddEdit extends IOrthOV1ProcedurePhotosProps, ICustomControlProcedureAddEditProps {
    isReadOnly: false;
    setIsSaveButtonDisabled: Dispatch<SetStateAction<boolean>>;
}

interface IOrthOProcedurePhotosRead extends IOrthOV1ProcedurePhotosProps, ICustomControlProcedureReadProps {
    isReadOnly: true;
}

type IOrthOV1ProcedurePhotos = IOrthOV1ProcedurePhotosAddEdit | IOrthOProcedurePhotosRead;

export function OrthOV1ProcedurePhotos(props: IOrthOV1ProcedurePhotos) {
    return (
        <>
            <HeaderDivider text={props.title ? props.title : "Foto's (fundus, OCT, etc.)"} />

            {!props.isReadOnly && (
                <>
                    <OphthalmologyDropzoneProcedureAddEdit
                        assets={props.procedure.customControlData.files}
                        handleChangeCustomControl={props.handleChangeCustomControl}
                        isAutoSaveActive={props.isAutoSaveActive}
                        onUploading={async (isUploading) => await props.setIsSaveButtonDisabled(isUploading)}
                        procedure={props.procedure}
                        service={props.service}
                    />
                    <Alert appearance="info">
                        {props.isOrthOFol
                            ? 'Let op: voor dit vervolg orthoptisch onderzoek is een centrale fundusfoto verplicht (indien mogelijk).'
                            : 'Let op: voor het eerste orthoptisch onderzoek is een centrale fundusfoto verplicht (indien mogelijk).'}
                    </Alert>
                </>
            )}

            {props.isReadOnly && (
                <OphthalmologyDropzoneRead
                    files={props.procedure.customControlData.files}
                    id={props.procedure.id}
                />
            )}
        </>
    );
}
